import { useMutation, useQueryClient } from '@tanstack/react-query';

import { propertyQueryKeys } from '~/hooks/apis/accommodation/useGetProperty';

import ReservationService from '~/services/ReservationService';

export interface DeleteRoomRateParams {
  propertyId: string;
  roomTypeId: string;
  roomRateId: string;
}

export function useDeleteRoomRate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ propertyId, roomTypeId, roomRateId }: DeleteRoomRateParams) =>
      ReservationService.deleteRoomRate(roomRateId, propertyId, roomTypeId),
    onSuccess: (_data, { propertyId }) => {
      queryClient.invalidateQueries({ queryKey: propertyQueryKeys.detail(propertyId) });
    },
  });
}
